import { atom } from 'recoil';

export const favoriteStatusAtom = atom({
  key: 'favoriteStatusAtom',
  default: 0,
});
